<section class="insulation-shell" *ngIf="tagNumber$ | async as tagNumber">
  <div class="insulation-shell__placeholder" *ngIf="insulationLoading$ | async">Loading insulation data...</div>

  <div class="insulation-shell__tables" *ngIf="(currentInsulationTag$ | async) === tagNumber && !(insulationLoading$ | async)">
    <h3 class="insulation-shell__table-title">Insulations</h3>
    <p-table [value]="insulations$ | async" [tableStyle]="{ 'min-width': '40rem', 'table-layout': 'fixed' }" styleClass="p-datatable-sm">
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col style="width: 14%" />
          <col style="width: 38%" />
          <col style="width: 18%" />
          <col style="width: 14%" />
          <col style="width: 16%" />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>No</th>
          <th>Description</th>
          <th>Status Name</th>
          <th>Status</th>
          <th>Checklist</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [class.insulation-shell__row--clickable]="isRowClickable(row)">
          <td>
            <ng-container *ngIf="rowRoute(row) as link; else insulationNoPlain">
              <a class="insulation-shell__cell-link" [routerLink]="link" [queryParams]="rowQueryParams(row)">{{ row.no }}</a>
            </ng-container>
            <ng-template #insulationNoPlain>{{ row.no }}</ng-template>
          </td>
          <td>
            <ng-container *ngIf="rowRoute(row) as link; else insulationDescriptionPlain">
              <a class="insulation-shell__cell-link" [routerLink]="link" [queryParams]="rowQueryParams(row)">{{ row.description }}</a>
            </ng-container>
            <ng-template #insulationDescriptionPlain>{{ row.description }}</ng-template>
          </td>
          <td>
            <ng-container *ngIf="rowRoute(row) as link; else insulationStatusNamePlain">
              <a class="insulation-shell__cell-link" [routerLink]="link" [queryParams]="rowQueryParams(row)">{{ row.statusName }}</a>
            </ng-container>
            <ng-template #insulationStatusNamePlain>{{ row.statusName }}</ng-template>
          </td>
          <td>
            <ng-container *ngIf="rowRoute(row) as link; else insulationStatusPlain">
              <a class="insulation-shell__cell-link" [routerLink]="link" [queryParams]="rowQueryParams(row)">{{ row.status }}</a>
            </ng-container>
            <ng-template #insulationStatusPlain>{{ row.status }}</ng-template>
          </td>
          <td class="insulation-shell__status-cell">
            <ng-container *ngIf="rowRoute(row) as link; else insulationChecklistPlain">
              <a class="insulation-shell__cell-link" [routerLink]="link" [queryParams]="rowQueryParams(row)">
                <div class="insulation-shell__status-content">
                  {{ row.checklistStatus.name }}
                  <app-status-circle [status]="row.checklistStatus.name" [useSmall]="true" />
                </div>
              </a>
            </ng-container>
            <ng-template #insulationChecklistPlain>
              <div class="insulation-shell__status-content">
                {{ row.checklistStatus.name }}
                <app-status-circle [status]="row.checklistStatus.name" [useSmall]="true" />
              </div>
            </ng-template>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <h3 class="insulation-shell__table-title">Insulation Boxes</h3>
    <p-table [value]="insulationBoxes$ | async" [tableStyle]="{ 'min-width': '40rem', 'table-layout': 'fixed' }" styleClass="p-datatable-sm">
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col style="width: 14%" />
          <col style="width: 38%" />
          <col style="width: 18%" />
          <col style="width: 14%" />
          <col style="width: 16%" />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>No</th>
          <th>Description</th>
          <th>Status Name</th>
          <th>Status</th>
          <th>Checklist</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [class.insulation-shell__row--clickable]="isRowClickable(row)">
          <td>
            <ng-container *ngIf="rowRoute(row) as link; else boxNoPlain">
              <a class="insulation-shell__cell-link" [routerLink]="link" [queryParams]="rowQueryParams(row)">{{ row.no }}</a>
            </ng-container>
            <ng-template #boxNoPlain>{{ row.no }}</ng-template>
          </td>
          <td>
            <ng-container *ngIf="rowRoute(row) as link; else boxDescriptionPlain">
              <a class="insulation-shell__cell-link" [routerLink]="link" [queryParams]="rowQueryParams(row)">{{ row.description }}</a>
            </ng-container>
            <ng-template #boxDescriptionPlain>{{ row.description }}</ng-template>
          </td>
          <td>
            <ng-container *ngIf="rowRoute(row) as link; else boxStatusNamePlain">
              <a class="insulation-shell__cell-link" [routerLink]="link" [queryParams]="rowQueryParams(row)">{{ row.statusName }}</a>
            </ng-container>
            <ng-template #boxStatusNamePlain>{{ row.statusName }}</ng-template>
          </td>
          <td>
            <ng-container *ngIf="rowRoute(row) as link; else boxStatusPlain">
              <a class="insulation-shell__cell-link" [routerLink]="link" [queryParams]="rowQueryParams(row)">{{ row.status }}</a>
            </ng-container>
            <ng-template #boxStatusPlain>{{ row.status }}</ng-template>
          </td>
          <td class="insulation-shell__status-cell">
            <ng-container *ngIf="rowRoute(row) as link; else boxChecklistPlain">
              <a class="insulation-shell__cell-link" [routerLink]="link" [queryParams]="rowQueryParams(row)">
                <div class="insulation-shell__status-content">
                  {{ row.checklistStatus.name }}
                  <app-status-circle [status]="row.checklistStatus.name" [useSmall]="true" />
                </div>
              </a>
            </ng-container>
            <ng-template #boxChecklistPlain>
              <div class="insulation-shell__status-content">
                {{ row.checklistStatus.name }}
                <app-status-circle [status]="row.checklistStatus.name" [useSmall]="true" />
              </div>
            </ng-template>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>


